/* BVONA FORTVNA — Complimentary Bag Discount
   Applies BVONA-INCLUDED discount code to cart whenever
   a comp-bag-eligible product is present.
   Fixed: removed syntax error, cleaned up logic.
*/
(function () {
  var CODE = 'BVONA-INCLUDED';

  // Variant IDs of the comp-bag-eligible Dawn products (plain bags, no charm)
  // IL LUNGO colours
  var compBagVariants = [
    '41383475118245', // Testa Rossa Lungo
    '41959828029605', // Barolo Lungo
    '41383477379237', // Quadrifoglio Lungo
    '41383477739685', // Oliva Lungo
    '41383478165669', // Champagna Lungo
    '41383478395045', // Nonna Black Lungo
    '41383479574693', // Fuchsia Lungo
    '41912340218021', // Azzurri Lungo
    '41383480098981', // Figlio D’Oro Lungo
    '41383480230053', // Ferro Lungo
    // IL PICCOLO colours
    '41383538852005', // Testa Rossa Piccolo
    '41383538983077', // Barolo Piccolo
    '41383539474597', // Quadrifoglio Piccolo
    '41383539638437', // Oliva Piccolo
    '41383539867813', // Champagna Piccolo
    '41383540490405', // Nonna Black Piccolo
    '41383540981925', // Fuchsia Piccolo
    '41966078492837', // Azzurri Piccolo
    '41383541407909', // Figlio D’Oro Piccolo
    '41383556120741'  // Ferro Piccolo
  ];

  var compBagSet = {};
  compBagVariants.forEach(function (id) { compBagSet[id] = true; });

  function cartContainsCompBag(cartItems) {
    return cartItems.some(function (item) {
      return compBagSet[String(item.variant_id)] || compBagSet[String(item.id)];
    });
  }

  function applyDiscount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cartContainsCompBag(cart.items)) {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ discount: CODE })
          }).catch(function (e) {
            console.warn('BVONA discount apply failed:', e);
          });
        }
      })
      .catch(function (e) {
        console.warn('BVONA cart fetch failed:', e);
      });
  }

  // Intercept cart/add.js to apply discount after any add
  var originalFetch = window.fetch;
  window.fetch = function (url, options) {
    var result = originalFetch.apply(this, arguments);
    if (typeof url === 'string' && url.indexOf('/cart/add.js') !== -1) {
      result = result.then(function (response) {
        if (response.ok) {
          applyDiscount();
        }
        return response;
      });
    }
    return result;
  };

  // Also apply on page load in case cart already has a comp bag
  document.addEventListener('DOMContentLoaded', function () {
    applyDiscount();
  });

})();
